/** @jsxRuntime automatic */
/** @jsxImportSource @fluentui/react-jsx-runtime */

import { assertSlots, Menu } from '@fluentui/react-components';
import type { JSXElement } from '@fluentui/react-utilities';
import type {
  GroundingCommandBarOverflowMenuState,
  GroundingCommandBarOverflowMenuSlots,
} from './GroundingCommandBarOverflowMenu.types';

/**
 * Render the final JSX of GroundingCommandBarOverflowMenu
 */
export const renderGroundingCommandBarOverflowMenu_unstable = (
  state: GroundingCommandBarOverflowMenuState,
): JSXElement => {
  assertSlots<GroundingCommandBarOverflowMenuSlots>(state);

  return (
    <state.root>
      {state.isOverflowing && state.menuButton && state.menuList && state.menuPopover && state.menuTrigger ? (
        <Menu>
          <state.menuTrigger>
            <state.menuButton />
          </state.menuTrigger>
          <state.menuPopover>
            <state.menuList />
          </state.menuPopover>
        </Menu>
      ) : null}
    </state.root>
  );
};
